import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";

import COLOR_THEMES from "../../../../../colorThemes";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {setLookActiveCategory, setLookMoreInfoOpened, setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_FEATURE_CONTENT, LOOK_OVERLAYS} from "../../../core/constants";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";

import {Look3DIcon} from "../../../../common/icons";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import LookLockedButton from "../../../lookNavigation/lookMain/lookLockedButton";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {categoryIsInTheWizard} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import GroheFeatureWizardButton from "./groheFeatureWizardButton";
import {getDbFeatureProperty} from "../../../lookNavigation/lookFunctions2";

const GroheFeatureTopButtons = (props) => {

  const {lookActiveFeature, setLookMoreInfoOpened, moreInfoOpened, moreInfoContent, activeTheme, setLookOverlayOpened,
    isMobile, lookFeature, lookActiveCategory, wizardList, activePreset, wizardActiveItem} = props;

  if (isMobile) {
    return null
  }

  const feature = lookFeature || lookActiveFeature;

  const featureIsLocked = getFeatureIsLocked(feature);
  const threeDDisabled = !feature.dbFeature[getDbFeatureProperty("lixilQRCode")] && !Array.isArray(feature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")]);

  const threeDButtonClick = () => {
    if (featureIsLocked) {
      if (IS_PRODUCT_JOURNEY) {
        Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureLocked3DButton);
      }
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      return false
    }

    let moreInfoType = "";
    if (IS_PRODUCT_JOURNEY) {
      Analytics.sendClickEvent(moreInfoOpened ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeature3dAndArClose : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeature3dAndArOpen);
      moreInfoType = moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.threeD) ? "" : feature ? "select" : "main";
    } else {
      Analytics.sendClickEvent(moreInfoOpened ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeature3dAndArClose : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeature3dAndArOpen);
      moreInfoType = moreInfoOpened && (moreInfoContent !== LOOK_FEATURE_CONTENT.info) ? "" : lookActiveCategory ? "select" : "main";
    }
    //setLookActiveCategory("");

    const contentToOpen = Array.isArray(feature.dbFeature[getDbFeatureProperty("lixilAR3DUrls")])
      ? LOOK_FEATURE_CONTENT.threeD
      : LOOK_FEATURE_CONTENT.aug

    setLookMoreInfoOpened(moreInfoType, contentToOpen);
  };

  const hasWizard = !wizardActiveItem && categoryIsInTheWizard(wizardList, feature.partId, activePreset);

  return (
    <div className={"lk-button" + (IS_PRODUCT_JOURNEY ? "" : " lk-button3d") + (hasWizard ? " lk-button--double" : "")}>
      <Button className={"look-button look-button--secondary look-button--3d"
        + (IS_PRODUCT_JOURNEY ? " grohe-look__button" : "")
        + (featureIsLocked ? " look-button--disabled" : "")}
              disabled={threeDDisabled}
              startIcon={(
                <SvgIcon className={"look-icon--small"}>
                  <Look3DIcon color={COLOR_THEMES[activeTheme].primary} />
                </SvgIcon>
              )}
              onClick={threeDButtonClick}>
        <FormattedMessage id={hasWizard ? "look.feature.3dButton.small" : "look.feature.3dButton"}/>
      </Button>
      {featureIsLocked && !hasWizard ? <LookLockedButton/> : null}
      {hasWizard ? <GroheFeatureWizardButton feature={feature} hasWizard={hasWizard}/> : null}
    </div>
  )
};

GroheFeatureTopButtons.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, moreInfoOpened, moreInfoContent, lookActiveCategory} = store.lookState;
  const {isMobile, activeTheme} = store.serverState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {wizardActiveItem, wizardList} = store.wizardState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    lookActiveFeature,
    moreInfoOpened,
    moreInfoContent,
    lookActiveCategory,
    isMobile,
    activeTheme,
    isPhoneNumberValidated,
    wizardList,
    activePreset,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookMoreInfoOpened,
  updateCanvasCount,
  setLookOverlayOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureTopButtons)
)
